// eslint-disable-next-line import/prefer-default-export
export function objectToQueryString(obj: Record<string, string | number>) {
  const keys = Object.keys(obj)
  const keyValuePairs = keys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)

  return keyValuePairs.join('&')
}
